<template>
  <div>
    <div class="page page__list" v-if="!isType">
      <search-bar
        @search="onSearch"
        name="ap_code,ap_agentname,cu_proddesc"
        placeholder="输入单号、代理商、产品种类进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/agent/price/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.ap_code}}</p>
            <p class="list-item-muted">{{item.cu_proddesc}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.ap_agentname}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.ap_status!='已审核'}"
            >
              {{item.ap_status}}
            </span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}条</label>
      </div>
      <add-button to="/agent/price_edit" />
    </div>

    <div class="page page__list" v-if="isType">
      <search-bar
        @search="onSearch"
        name="ap_code,ap_agentname,cu_proddesc"
        placeholder="输入单号、代理商、产品种类进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.ap_id"
          :to="'/agent/price/'+item.ap_id"
        >
          <div class="weui-cell__bd">
            <p>{{item.ap_code}}</p>
            <p class="list-item-muted">{{item.cu_proddesc}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.ap_agentname}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.ap_status!='已审核'}"
            >
              {{item.ap_status}}
            </span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}条</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      isType: false,
      listUrl: "/api/agent/agentprice/list",
      filters: [
        {
          type: "date",
          name: "ap_startdate"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "折扣",
              condition: "ap_kind='折扣'"
            },
            {
              value: 2,
              label: "返点",
              condition: "ap_kind='返点'"
            }
          ]
        }
      ],
    }
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      let isType = filter.value > 0
      this.listUrl = isType ? '/api/agent/agentprice/type/list' : '/api/agent/agentprice/list'
      this.isType = isType ? true : false
      filterBar.initConfig()
      next()
    },
  }
}
</script>